/**
 * Typography
 */

const headlineLetterSpacing = '0.035rem'; // copied from tachyons values

export default {
  headlineLetterSpacing,
};
